// Optimize() defaults: NH=3, TH=6, DH=10, SP=6
export const adwinProgram = `
  c          = close
  h          = high
  l          = low
  prevC1     = prev(c, 0)

  part1      = linRegSlope(c, 3)

  deltaC     = c - prevC1
  absDeltaC  = abs(deltaC)
  emaD_dc    = ema(deltaC, 10)
  emaT_dc    = ema(emaD_dc, 6)
  emaD_abs   = ema(absDeltaC, 10)
  emaT_abs   = ema(emaD_abs, 6)
  part2      = nanToZero(emaT_dc / emaT_abs) * 100

  hhv3       = hhv(h, 3)
  llv3       = llv(l, 3)
  midpoint   = (hhv3 + llv3) / 2
  rangeHL    = hhv3 - llv3
  cMinusMid  = c - midpoint
  emaTH_cm   = ema(cMinusMid, 6)
  emaSP_cm   = ema(emaTH_cm, 6)
  emaTH_rng  = ema(rangeHL, 6)
  emaSP_rng  = ema(emaTH_rng, 6)
  part3      = nanToZero(emaSP_cm / emaSP_rng) * 200

  adwinDoScope = part1 + part2 + part3
`

// Stochastic %K with smoothing. Equivalent to StochK(period, smooth) in AmiBroker.
// Defaults match AFL: period=15, smooth=3.
export const stochProgram = `
  hh    = hhv(high, 15)
  ll    = llv(low, 15)
  denom = hh - ll
  rawK  = nanToZero((close - ll) / denom) * 100
  k     = sma(rawK, 3)
`

export const moneyFlowProgram = `
  bp     = close - min(low, prev(close, 0))
  sp     = max(high, prev(close, 0)) - close
  bpavg  = ema(bp, 80)
  spavg  = ema(sp, 80)
  nbp    = bp / bpavg
  nsp    = sp / spavg
  varg   = ema(volume, 80)
  nv     = volume / varg
  nbfraw = nanToZero(nbp * nv)
  nsfraw = nanToZero(nsp * nv)
  nbf    = ema(nbfraw, 20)
  nsf    = ema(nsfraw, 20)
  diff   = nbf - nsf
`
